module.exports = __webpack_public_path__ + "assets/d19f84548bd06195f623f29b6332778f.svg";